import type { UnleashToggles } from '@/interfaces';

const kayakToThonMapping = {
    86367: 'AESALE', // Thon Hotel Ålesund, Ålesund, Norge
    6069255: 'AESBAR', // Thon Partner Hotel Baronen, Ålesund, Norge
    337737: 'ALFALT', // Thon Hotel Alta, Alta, Norge
    244427: 'ALFKAN', // Thon Hotel Kautokeino, Kautokeino, Norge
    85074: 'ANXAND', // Thon Partner Hotel Andrikken, Andenes, Norge
    11969: 'BGOAIR', // Thon Hotel Bergen Airport, Bergen, Norge
    15266: 'BGOBRI', // Thon Hotel Bristol Bergen, Bergen, Norge
    12218: 'BGOBRY', // Thon Hotel Orion, Bergen, Norge
    21367: 'BGOROS', // Thon Hotel Rosenkrantz Bergen, Bergen, Norge
    413758: 'BGOTHS', // Thon Hotel Sandven, Kvam, Norge
    3465: 'BNNBRO', // Thon Hotel Brønnøysund, Brønnøysund, Norge
    337738: 'BNNTOR', // Thon Hotel Torghatten, Brønnøysund, Norge
    8206: 'BOONOR', // Thon Hotel Nordlys", Bodø, Norge
    25723: 'BOOSKA', // Thon Partner Hotel Skagen, Bodø, Norge
    80962: 'DLDHAL', // Thon Hotel Hallingdal, Ål, Norge
    444: 'FDEFOR', // Thon Partner Hotel Førde, Førde, Norge
    59254: 'FDEJOL', // Thon Partner Hotel Jølster, Jølster, Norge
    7778: 'HAUSAG', // Thon Partner Hotel Saga, Haugesund, Norge
    420695: 'HFTTHO', // Thon Hotel Hammerfest, Hammerfest, Norge
    86125: 'HMRCTR', // Thon Partner Hotel Central, Elverum, Norge
    614619: 'HMRELG', // Thon Partner Elgstua, Elverum, Norge *Really, really bad data*
    119097: 'HMROTT', // Thon Partner Hotel Otta, Otta, Norge
    5996: 'HMRSKE', // Thon Hotel Skeikampen, Gausdal, Norge
    74757: 'HMRVIC', // Thon Partner Hotel Victoria Hamar, Hamar, Norge
    2202139: 'HOVFOS', // Thon Hotel Fosnavåg, Herøy, Norge
    159325: 'HRDHAR', // Thon Hotel Harstad, Harstad, Norge
    6088510: 'HRDNAR', // Thon Partner Hotel Narvik, Narvik, Norge
    346546: 'KKNKIR', // Thon Hotel Kirkenes, Kirkenes, Norge
    159326: 'KRSARE', // Thon Hotel Arendal, Arendal, Norge
    31151: 'KRSKRI', // Thon Partner Hotel Kristiansand, Kristiansand, Norge
    80949: 'KRSPAR', // Thon Partner Hotel Parken", Kristiansand, Norge
    316816: 'KSUKRI', // Thon Hotel Kristiansund, Kristiansund, Norge
    59226: 'KSUSTO', // Thon Partner Hotel Storgata, Kristiansund, Norge
    413850: 'KSUTHV', // Thon Partner Hotel Surnadal, Surnadal, Norge
    5698: 'MOLMOL', // Thon Hotel Moldefjord, Molde, Norge
    311353: 'OSLAIR', // Thon Hotel Oslo Airport, Oslo, Norge
    25470: 'OSLARE', // Thon Hotel Arena, Lillestrøm, Norge
    130231: 'OSLAST', // Thon Hotel Astoria, Oslo, Norge
    74722: 'OSLBRI', // Hotel Bristol, Oslo, Norge
    100715: 'OSLCAR', // Thon Hotel Lillestrøm, Lillestrøm, Norge
    59242: 'OSLCEC', // Thon Hotel Cecil, Oslo, Norge
    134515: 'OSLEUR', // Thon Hotel Europa, Oslo, Norge
    59253: 'OSLFJO', // Thon Hotel Oslofjord, Bærum, Norge
    159330: 'OSLGYL', // Thon Hotel Gyldenløve, Oslo, Norge
    161230: 'OSLIES', // Thon Hotel Gardermoen, Oslo, Norge
    74769: 'OSLLIN', // Thon Hotel Linne, Oslo, Norge
    37187: 'OSLMUN', // Thon Hotel Munch, Oslo, Norge
    34782: 'OSLOPE', // Thon Hotel Opera, Oslo, Norge
    126948: 'OSLSKI', // Thon Hotel Ski, Ski, Norge
    59237: 'OSLSLO', // 'Thon Hotel Slottsparken, Oslo, Norge
    13745: 'OSLSPE', // Thon Hotel Spectrum, Oslo, Norge
    13720: 'OSLSTE', // Thon Hotel Rosenkrantz Oslo, Oslo, Norge
    3935247: 'OSLSTO', // Thon Hotel Storo, Oslo, Norge
    59243: 'OSLTER', // Thon Hotel Terminus, Oslo, Norge
    309704: 'OSLULL', // Thon Hotel Ullevaal Stadion, Oslo, Norge
    333912: 'OSLVET', // Thon Hotel Vettre, Asker, Norge
    59244: 'OSLVIK', // Thon Hotel Vika Atrium, Oslo, Norge
    241736: 'RYGHAL', // Thon Hotel Halden, Halden, Norge
    6069253: 'SDNMAL', // Thon Partner Hotel Måløy, Måløy, Norge
    59255: 'SKEHOY', // Thon Hotel Høyers, Skien, Norge
    8021604: 'SVGFOR', // Thon Partner Stavanger Forum Hotel, Stavanger, Norge
    13548: 'SVGMAR', // Thon Hotel Maritim, Stavanger, Norge
    159328: 'SVGSAN', // Thon Partner Hotel Sandnes, Sandnes, Norge
    2623348: 'SVGSTA', // Thon Hotel Stavanger, Stavanger, Norge
    329306: 'SVJLOF', // Thon Hotel Lofoten, Lofoten, Norge
    59261: 'TOSPOL', // Thon Hotel Polar, Tromsø, Norge
    336868: 'TOSTRO', // Thon Hotel Tromsø, Tromsø, Norge
    1035: 'TRDBAC', // Thon Partner Hotel Backlund, Levanger, Norge
    80955: 'TRDGVH', // Thon Hotel Nidaros, Trondheim, Norge
    59265: 'TRDTRO', // Thon Hotel Trondheim, Trondheim, Norge
    211538: 'TRDVER', // Thon Hotel Verdal, Verdal, Norge
    4678: 'TRFBRY', // Thon Hotel Tønsberg Brygge, Tønsberg, Norge
    6087806: 'TRFHOR', // Thon Partner Hotel Horten, Horten, Norge
    375373: 'XVKTHB', // Thon Hotel Bjørneparken, Flå, Norge
    1070229923: 'KRSNOR', // Thon Partner Hotel Norge, Kristiansand, Norge
};

const hcToThonMapping = {
    /*1436814: 'BRUAIR', // Thon Hotel Brussels Airport, Brüssel, Belgia
    1045275: 'BRUBRI', // Thon Hotel Bristol Stephanie", Brussel, Belgia
    1227550: 'BRUBRU', // Thon Hotel Brussels City Centre, Brussel, Belgia
    1708406: 'BRUEUR', // Thon Hotel EU, Brussel, Belgia
    1045262: 'BRUFLO', // Thon Residence Florence, Brussel, Belgia
    1250396: 'BRUPAR', // Thon Residence Parnasse, Brussel, Belgia
    1045332: 'BRUSTA', // Stanhope Hotel Brussels", Brussel, Belgia
    1062645: 'RTMROT', // Thon Hotel Rotterdam, Rotterdam, Nederland*/
    1125978: 'AESALE', // Thon Hotel Ålesund, Ålesund, Norge
    1125975: 'AESBAR', // Thon Partner Hotel Baronen, Ålesund, Norge
    1598630: 'ALFALT', // Thon Hotel Alta, Alta, Norge
    1440116: 'ALFKAN', // Thon Hotel Kautokeino, Kautokeino, Norge
    1125987: 'ANXAND', // Thon Partner Hotel Andrikken, Andenes, Norge
    /*1542395: 'BASECAMP', // Basecamp Explorer Spitsbergen, Svalbard, Norge*/
    1207985: 'BGOAIR', // Thon Hotel Bergen Airport, Bergen, Norge
    1126023: 'BGOBRI', // Thon Hotel Bristol Bergen, Bergen, Norge
    1207984: 'BGOBRY', // Thon Hotel Orion, Bergen, Norge
    1126024: 'BGOROS', // Thon Hotel Rosenkrantz Bergen, Bergen, Norge
    1708182: 'BGOTHS', // Thon Hotel Sandven, Kvam, Norge
    1364306: 'BNNBRO', // Thon Hotel Brønnøysund, Brønnøysund, Norge
    1645484: 'BNNTOR', // Thon Hotel Torghatten, Brønnøysund, Norge
    1207986: 'BOONOR', // Thon Hotel Nordlys", Bodø, Norge
    1126038: 'BOOSKA', // Thon Partner Hotel Skagen, Bodø, Norge
    1125969: 'DLDHAL', // Thon Hotel Hallingdal, Ål, Norge
    1573241: 'FDEFOR', // Thon Partner Hotel Førde, Førde, Norge
    1126383: 'FDEJOL', // Thon Partner Hotel Jølster, Jølster, Norge
    1126101: 'HAUSAG', // Thon Partner Hotel Saga, Haugesund, Norge
    1241283: 'HFTTHO', // Thon Hotel Hammerfest, Hammerfest, Norge
    1126052: 'HMRCTR', // Thon Partner Hotel Central, Elverum, Norge
    1710473: 'HMRELG', // Thon Partner Elgstua, Elverum, Norge *Really, really bad data*
    1420940: 'HMROTT', // Thon Partner Hotel Otta, Otta, Norge
    1572835: 'HMRSKE', // Thon Hotel Skeikampen, Gausdal, Norge
    1126086: 'HMRVIC', // Thon Partner Hotel Victoria Hamar, Hamar, Norge
    2531865: 'HOVFOS', // Thon Hotel Fosnavåg, Herøy, Norge
    1207995: 'HRDHAR', // Thon Hotel Harstad, Harstad, Norge
    1126328: 'HRDNAR', // Thon Partner Hotel Narvik, Narvik, Norge
    1594181: 'KKNKIR', // Thon Hotel Kirkenes, Kirkenes, Norge
    1125990: 'KRSARE', // Thon Hotel Arendal, Arendal, Norge
    1126192: 'KRSKRI', // Thon Partner Hotel Kristiansand, Kristiansand, Norge
    1207999: 'KRSPAR', // Thon Partner Hotel Parken", Kristiansand, Norge
    1535063: 'KSUKRI', // Thon Hotel Kristiansund, Kristiansund, Norge
    1466137: 'KSUSTO', // Thon Partner Hotel Storgata, Kristiansund, Norge
    1712072: 'KSUTHV', // Thon Partner Hotel Surnadal, Surnadal, Norge
    1208007: 'MOLMOL', // Thon Hotel Moldefjord, Molde, Norge
    1417228: 'OSLAIR', // Thon Hotel Oslo Airport, Oslo, Norge
    1217257: 'OSLARE', // Thon Hotel Arena, Lillestrøm, Norge
    1126267: 'OSLAST', // Thon Hotel Astoria, Oslo, Norge
    1126269: 'OSLBRI', // Hotel Bristol, Oslo, Norge
    1291019: 'OSLCAR', // Thon Hotel Lillestrøm, Lillestrøm, Norge
    1208011: 'OSLCEC', // Thon Hotel Cecil, Oslo, Norge
    1208012: 'OSLEUR', // Thon Hotel Europa, Oslo, Norge
    1126239: 'OSLFJO', // Thon Hotel Oslofjord, Bærum, Norge
    1208017: 'OSLGYL', // Thon Hotel Gyldenløve, Oslo, Norge
    1267530: 'OSLIES', // Thon Hotel Gardermoen, Oslo, Norge
    1241326: 'OSLLIN', // Thon Hotel Linne, Oslo, Norge
    1208023: 'OSLMUN', // Thon Hotel Munch, Oslo, Norge
    1208015: 'OSLOPE', // Thon Hotel Opera, Oslo, Norge
    1126601: 'OSLSKI', // Thon Hotel Ski, Ski, Norge
    1208009: 'OSLSLO', // 'Thon Hotel Slottsparken, Oslo, Norge
    1126270: 'OSLSPE', // Thon Hotel Spectrum, Oslo, Norge
    1208013: 'OSLSTE', // Thon Hotel Rosenkrantz Oslo, Oslo, Norge
    4441509: 'OSLSTO', // Thon Hotel Storo, Oslo, Norge
    1208008: 'OSLTER', // Thon Hotel Terminus, Oslo, Norge
    1535171: 'OSLULL', // Thon Hotel Ullevaal Stadion, Oslo, Norge
    1212937: 'OSLVET', // Thon Hotel Vettre, Asker, Norge
    1208014: 'OSLVIK', // Thon Hotel Vika Atrium, Oslo, Norge
    1502410: 'RYGHAL', // Thon Hotel Halden, Halden, Norge
    1126240: 'SDNMAL', // Thon Partner Hotel Måløy, Måløy, Norge
    1208032: 'SKEHOY', // Thon Hotel Høyers, Skien, Norge
    1126404: 'SVGFOR', // Thon Partner Stavanger Forum Hotel, Stavanger, Norge
    1208033: 'SVGMAR', // Thon Hotel Maritim, Stavanger, Norge
    1208030: 'SVGSAN', // Thon Partner Hotel Sandnes, Sandnes, Norge
    3068627: 'SVGSTA', // Thon Hotel Stavanger, Stavanger, Norge
    1241336: 'SVJLOF', // Thon Hotel Lofoten, Lofoten, Norge
    1126438: 'TOSPOL', // Thon Hotel Polar, Tromsø, Norge
    1598429: 'TOSTRO', // Thon Hotel Tromsø, Tromsø, Norge
    1126214: 'TRDBAC', // Thon Partner Hotel Backlund, Levanger, Norge
    1126455: 'TRDGVH', // Thon Hotel Nidaros, Trondheim, Norge
    1126456: 'TRDTRO', // Thon Hotel Trondheim, Trondheim, Norge
    1126468: 'TRDVER', // Thon Hotel Verdal, Verdal, Norge
    1502381: 'TRFBRY', // Thon Hotel Tønsberg Brygge, Tønsberg, Norge
    1241285: 'TRFHOR', // Thon Partner Hotel Horten, Horten, Norge
    1708146: 'XVKTHB', // Thon Hotel Bjørneparken, Flå, Norge
    1126191: 'KRSNOR', // Thon Partner Hotel Norge, Kristiansand, Norge
    /*1614082: 'ARDKUN', // Thon Partner Hotel Kungsbron, Stockholm, Sverige
    1127966: 'CPHHOJ', // Thon Partner Hotel Høje Taastrup, Danmark *Really, really bad data**/
};

export const hcFilenameToThonMapping = {
    /*thon_hotel_brussels_airport: 'BRUAIR', // Thon Hotel Brussels Airport, Brussel, Belgia
    thon_hotel_bristol_stephanie: 'BRUBRI', // Thon Hotel Bristol Stephanie, Brussel, Belgia
    thon_hotel_brussels_city_centre: 'BRUBRU', // Thon Hotel Brussels City Centre, Brussel, Belgia
    thon_hotel_eu: 'BRUEUR', // "Thon Hotel EU, Brussel, Belgia
    thon_residence_florence_aparthotel: 'BRUFLO', // Thon Residence Florence, Brussel, Belgia
    thon_residence_parnasse: 'BRUPAR', // Thon Residence Parnasse, Brussel, Belgia
    stanhope_hotel_brussels: 'BRUSTA', // Stanhope Hotel Brussels", Brussel, Belgia
    stanhope_hotel_brussels_by_thon_hotels: 'BRUSTA', // Stanhope Hotel Brussels", Brussel, Belgia
    thon_hotel_rotterdam: 'RTMROT', // Thon Hotel Rotterdam, Rotterdam, Nederland*/
    thon_hotel_alesund: 'AESALE', // Thon Hotel Ålesund, Norge
    thon_hotel_baronen: 'AESBAR', // Thon Partner Hotel Baronen, Ålesund, Norge
    thon_hotel_alta: 'ALFALT', // Thon Hotel Alta, Alta, Norge
    thon_hotel_kautokeino: 'ALFKAN', // Thon Hotel Kautokeino, Kautokeino, Norge
    thon_hotel_andrikken: 'ANXAND', // Thon Partner Hotel Andrikken, Andenes, Norge
    /*basecamp_hotel: 'BASECAMP', // Basecamp Explorer Spitsbergen, Svalbard, Norge*/
    thon_hotel_bergen_airport: 'BGOAIR', // Thon Hotel Bergen Airport, Bergen, Norge
    thon_hotel_bristol_bergen: 'BGOBRI', // Thon Hotel Bristol Bergen, Bergen, Norge
    thon_hotel_orion: 'BGOBRY', // Thon Hotel Orion, Bergen, Norge
    thon_hotel_rosenkrantz: 'BGOROS', // Thon Hotel Rosenkrantz Bergen, Bergen, Norge
    thon_hotel_sandven: 'BGOTHS', // Thon Hotel Sandven, Kvam, Norge
    thon_hotel_bronnoysund: 'BNNBRO', // Thon Hotel Brønnøysund, Brønnøysund, Norge
    thon_hotel_torghatten: 'BNNTOR', // Thon Hotel Torghatten, Brønnøysund, Norge
    thon_hotel_nordlys: 'BOONOR', // Thon Hotel Nordlys, Bodø, Norge
    skagen_hotel: 'BOOSKA', // Thon Partner Hotel Skagen, Bodø, Norge
    thon_hotel_hallingdal: 'DLDHAL', // Thon Hotel Hallingdal, Ål, Norge
    thon_hotel_forde: 'FDEFOR', // Thon Partner Hotel Førde, Førde, Norge
    thon_hotel_jolster: 'FDEJOL', // Thon Partner Hotel Jølster, Jølster, Norge *Really bad data*
    thon_hotel_saga: 'HAUSAG', // Thon Partner Hotel Saga, Haugesund, Norge
    thon_hotel_hammerfest: 'HFTTHO', // Thon Hotel Hammerfest, Hammerfest, Norge
    scandic_central_elverum: 'HMRCTR', // Thon Partner Hotel Central, Elverum, Norge *Really, really bad data*
    scandic_elgstua: 'HMRELG', // Thon Partner Elgstua, Elverum, Norge *Really, really bad data*
    thon_hotel_otta: 'HMROTT', // Thon Partner Hotel Otta, Otta, Norge
    thon_hotel_skeikampen: 'HMRSKE', // Thon Hotel Skeikampen, Gausdal, Norge
    first_hotel_victoria: 'HMRVIC', // Thon Partner Hotel Victoria Hamar, Hamar, Norge
    thon_hotel_fosnavag: 'HOVFOS', // Thon Hotel Fosnavåg, Herøy, Norge
    thon_hotel_harstad: 'HRDHAR', // Thon Hotel Harstad, Harstad, Norge
    thon_hotel_narvik: 'HRDNAR', // Thon Partner Hotel Narvik, Narvik, Norge
    thon_hotel_kirkenes: 'KKNKIR', // Thon Hotel Kirkenes, Kirkenes, Norge
    thon_hotel_arendal: 'KRSARE', // Thon Hotel Arendal, Arendal, Norge
    thon_hotel_kristiansand: 'KRSKRI', // Thon Partner Hotel Kristiansand, Kristiansand, Norge
    thon_hotel_wergeland: 'KRSPAR', // Thon Partner Hotel Parken, Kristiansand, Norge
    thon_hotel_kristiansund: 'KSUKRI', // Thon Hotel Kristiansund, Kristiansund, Norge
    thon_hotel_storgata: 'KSUSTO', // Thon Partner Hotel Storgata, Kristiansund, Norge
    thon_hotel_surnadal: 'KSUTHV', // Thon Partner Hotel Surnadal, Surnadal, Norge
    thon_hotel_moldefjord: 'MOLMOL', // Thon Hotel Moldefjord, Molde, Norge
    thon_hotel_oslo_airport: 'OSLAIR', // Thon Hotel Oslo Airport, Oslo, Norge
    thon_hotel_arena: 'OSLARE', // Thon Hotel Arena, Lillestrøm, Norge
    thon_hotel_astoria: 'OSLAST', // Thon Hotel Astoria, Oslo, Norge
    thon_hotel_bristol_oslo: 'OSLBRI', // Hotel Bristol, Oslo, Norge
    thon_hotel_lillestrom: 'OSLCAR', // Thon Hotel Lillestrøm, Lillestrøm, Norge
    thon_hotel_cecil: 'OSLCEC', // Thon Hotel Cecil, Oslo, Norge
    thon_hotel_europa: 'OSLEUR', // Thon Hotel Europa, Oslo, Norge
    thon_hotel_oslofjord: 'OSLFJO', // Thon Hotel Oslofjord, Bærum, Norge
    thon_hotel_gyldenlove: 'OSLGYL', // Thon Hotel Gyldenløve, Oslo, Norge
    thon_hotel_gardermoen: 'OSLIES', // Thon Hotel Gardermoen, Oslo, Norge
    thon_hotel_linne: 'OSLLIN', // Thon Hotel Linne, Oslo, Norge
    thon_hotel_munch: 'OSLMUN', // Thon Hotel Munch, Oslo, Norge
    thon_hotel_opera: 'OSLOPE', // Thon Hotel Opera, Oslo, Norge
    thon_hotel_ski: 'OSLSKI', // Thon Hotel Ski, Ski, Norge
    thon_hotel_slottsparken: 'OSLSLO', // 'Thon Hotel Slottsparken, Oslo, Norge
    thon_hotel_spectrum: 'OSLSPE', // Thon Hotel Spectrum, Oslo, Norge
    thon_hotel_rosenkrantz_oslo: 'OSLSTE', // Thon Hotel Rosenkrantz Oslo, Oslo, Norge
    thon_hotel_storo: 'OSLSTO', // Thon Hotel Storo, Oslo, Norge
    thon_hotel_terminus: 'OSLTER', // Thon Hotel Terminus, Oslo, Norge
    thon_hotel_ullevaal_stadion: 'OSLULL', // Thon Hotel Ullevaal Stadion, Oslo, Norge
    thon_hotel_vettre: 'OSLVET', // Thon Hotel Vettre, Asker, Norge
    thon_hotel_vika_atrium: 'OSLVIK', // Thon Hotel Vika Atrium, Oslo, Norge
    thon_hotel_halden: 'RYGHAL', // Thon Hotel Halden, Halden, Norge
    thon_hotel_maloy: 'SDNMAL', // Thon Partner Hotel Måløy, Måløy, Norge
    thon_hotel_hoyers: 'SKEHOY', // Thon Hotel Høyers, Skien, Norge
    stavanger_forum_hotel: 'SVGFOR', // Thon Partner Stavanger Forum Hotel, Stavanger, Norge
    thon_hotel_maritim: 'SVGMAR', // Thon Hotel Maritim, Stavanger, Norge
    thon_hotel_sandnes: 'SVGSAN', // Thon Partner Hotel Sandnes, Sandnes, Norge
    thon_hotel_stavanger: 'SVGSTA', // Thon Hotel Stavanger, Stavanger, Norge
    thon_hotel_lofoten: 'SVJLOF', // Thon Hotel Lofoten, Lofoten, Norge
    thon_hotel_polar: 'TOSPOL', // Thon Hotel Polar, Tromsø, Norge
    thon_hotel_tromso: 'TOSTRO', // Thon Hotel Tromsø, Tromsø, Norge
    thon_hotel_backlund: 'TRDBAC', // Thon Partner Hotel Backlund, Levanger, Norge
    thon_hotel_gildevangen: 'TRDGVH', // Thon Hotel Nidaros, Trondheim, Norge
    thon_hotel_trondheim: 'TRDTRO', // Thon Hotel Trondheim, Trondheim, Norge
    stiklestad_park_hotel: 'TRDVER', // Thon Hotel Verdal, Verdal, Norge
    thon_hotel_tonsberg_brygge: 'TRFBRY', // Thon Hotel Tønsberg Brygge, Tønsberg, Norge
    thon_hotel_horten: 'TRFHOR', // Thon Partner Hotel Horten, Horten, Norge
    thon_hotel_bjorneparken: 'XVKTHB', // Thon Hotel Bjørneparken, Flå, Norge
    thon_hotel_norge: 'KRSNOR', // Thon Partner Hotel Norge, Kristiansand, Norge
    /*first_hotel_kungsbron: 'ARDKUN', // Thon Partner Hotel Kungsbron, Stockholm, Sverige
    quality_hotel_hoje_taastrup: 'CPHHOJ', // Thon Partner Hotel Høje Taastrup, Danmark *Really, really bad data**/

    //missing: 'OSLSNO', Thon Hotel Snø: Lørenskog, Åpner juni 2023
    //missing: 'SVJSVO', Thon Hotel Svolvær, Svolvær, Norge (virker relativt nytt)
    //missing: Thon Partner Hotel Sortland, HRDSOR, // Thon Hotel Sortland, Sortland, Norge
    //missing: Thon Partner Hotel Vinstra, HMRVIN, Vinstra, Norge
};

const thonToHcFilenameMapping = Object.keys(hcFilenameToThonMapping).reduce((mappings: Record<string, string>, key) => {
    mappings[hcFilenameToThonMapping[key]] = key;

    return mappings;
}, {});

export const hasThonR9Mapping = (kayakHotelId: number | string): boolean => Object.keys(kayakToThonMapping).includes(String(kayakHotelId));

export const getThonR9Mapping = (kayakHotelId: number | string): string | undefined => kayakToThonMapping[kayakHotelId];

export const hasThonMapping = (hotelId: number): boolean => Object.keys(hcToThonMapping).includes(String(hotelId));

export const hasThonMappingAndEnabled = (hotelId: number, unleash: UnleashToggles): boolean =>
    unleash.thonDirectBooking && (unleash.newAutocomplete ? hasThonR9Mapping(hotelId) : hasThonMapping(hotelId));

export const getThonMapping = (hotelId: number): string | undefined => hcToThonMapping[hotelId];

export const hasThonFilenameMapping = (hotelFilename: string): boolean =>
    Object.keys(hcFilenameToThonMapping).includes(hotelFilename.toLowerCase());

export const hasThonFilenameMappingAndEnabled = (hotelFilename: string, unleash: UnleashToggles): boolean =>
    unleash.thonDirectBooking && (unleash.newAutocomplete ? hasThonR9Mapping(hotelFilename) : hasThonFilenameMapping(hotelFilename));

export const filenameToThonMapping = (hotelFilename: string): string | undefined => hcFilenameToThonMapping[hotelFilename.toLowerCase()];

export const thonToFilenameMapping = (thonHotelCode: string): string | undefined => thonToHcFilenameMapping[thonHotelCode];
